module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Slider/assets/alert_red-fd2fcd21b51a7ab346968a870d6b9071.svg";